import { Component } from '@angular/core';
import { NavbarComponent } from "../../../partials/navbar/navbar.component";
import { FooterComponent } from "../../../partials/footer/footer.component";
import { LanguageService } from '../../../services/language.service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-awards',
  standalone: true,
  imports: [NavbarComponent, FooterComponent],
  templateUrl: './awards.component.html',
  styleUrl: './awards.component.css'
})
export class AwardsComponent {
  texts: any;
  constructor(private langService:LanguageService, private title:Title){
    this.texts = this.langService.getWebisteTexts().awards;

    if (this.langService.getLanguage() == 'es') {
      this.title.setTitle('PRINX - Premios') 
    }else{
      this.title.setTitle('PRINX - Awards')
    }
  }
}
